export default __webpack_public_path__ + "static/media/87_photo.b6b64188.jpg";